import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { ContactCTA } from '../components/ContactCTA';
import { ServicesSection } from '../components/ServicesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { EmploymentSection } from '../components/EmploymentSection';
export function HomePage() {
  return <main data-id="element-819">
      <HeroSection data-id="element-820" />
      <AboutSection data-id="element-821" />
      <WhyChooseUs data-id="element-822" />
      <ContactCTA data-id="element-823" />
      <ServicesSection data-id="element-824" />
      <TestimonialsSection data-id="element-825" />
      <EmploymentSection data-id="element-826" />
    </main>;
}